import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../contexts/CartContext';
import { FiTrash2, FiPlus, FiMinus } from 'react-icons/fi';
import { SERVER } from '../hooks/config';
import '../styles/pages/Cart.scss';

const Cart = () => {
  const { items, updateQuantity, removeFromCart, getCartTotal, clearCart } = useCart();
  const navigate = useNavigate();

  const handleQuantityChange = (cartItemId, newQuantity) => {
    if (newQuantity <= 0) {
      removeFromCart(cartItemId);
    } else {
      updateQuantity(cartItemId, newQuantity);
    }
  };

  const handleCheckout = () => {
    navigate('/checkout');
  };

  if (items.length === 0) {
    return (
      <div className="cart-page">
        <div className="cart-container">
          <h1>Panier</h1>
          <div className="empty-cart">
            <p>Votre panier est vide</p>
            <button onClick={() => navigate('/Products')}>
              Continuer vos achats
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-page">
      <div className="cart-container">
        <h1>Panier</h1>
        
        <div className="cart-content">
          <div className="cart-items">
            {items.map((item) => (
              <div key={item.cartItemId} className="cart-item">
                <img 
                  src={item.image?.startsWith('/uploads/') ? `${SERVER}${item.image}` : item.image} 
                  alt={item.product_name}
                />
                <div className="item-details">
                  <h3>{item.product_name}</h3>
                  {item.selectedSize && (
                    <p className="selected-size">Taille: {item.selectedSize}</p>
                  )}
                  <p className="price">
                    {item.product_price} DT
                    {item.promotion > 0 && (
                      <span className="original-price">{item.original_price} DT</span>
                    )}
                  </p>
                </div>
                <div className="quantity-controls">
                  <button onClick={() => handleQuantityChange(item.cartItemId, item.quantity - 1)}>
                    <FiMinus />
                  </button>
                  <span>{item.quantity}</span>
                  <button onClick={() => handleQuantityChange(item.cartItemId, item.quantity + 1)}>
                    <FiPlus />
                  </button>
                </div>
                <div className="item-total">
                  {(item.product_price * item.quantity).toFixed(2)} DT
                </div>
                <button 
                  className="remove-btn"
                  onClick={() => removeFromCart(item.cartItemId)}
                >
                  <FiTrash2 />
                </button>
              </div>
            ))}
          </div>

          <div className="cart-summary">
            <h2>Résumé de la commande</h2>
            <div className="summary-item">
              <span>Sous-total:</span>
              <span>{getCartTotal().toFixed(2)} DT</span>
            </div>
            <div className="summary-item">
              <span>Livraison:</span>
              <span>8 DT</span>
            </div>
            <div className="summary-item total">
              <span>Total:</span>
              <span>{(getCartTotal() + 8).toFixed(2)} DT</span>
            </div>
            <button className="checkout-btn" onClick={handleCheckout}>
              Passer la commande
            </button>
            <button className="continue-shopping" onClick={() => navigate('/Products')}>
              Continuer vos achats
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cart;